module.exports = __webpack_public_path__ + "static/media/essve-design.897e01f6.jpg";